
const normalizeTouchEvent = (event) => {
  if(!event.touches || event.changedTouches.length === 0) {
    return event
  }
  return {...copyEventObject(event), ...copyEventObject(event.changedTouches[0])};
};

const copyEventObject = (event) => {
  const eventObject = {};

  for (const key in event) {
    if(typeof event[key] !== "function") {
      eventObject[key] = event[key];
    }
  }
  return eventObject;
}

export { normalizeTouchEvent }